<template>
  <div class="form-element-drop-down">
    <div @click.stop class="form-element-search-wrapper">
      <img :src="getImgUrl('./search-icon.svg')" class="search-icon" />
      <input v-model="searchElementType" />
    </div>
    <div
      class="element-list-wrapper fancy-scroll"
      @scroll.passive="setScrollbar"
    >
      <div
        v-for="(type, idx) in filterElementTypeList"
        :key="idx"
        class="item"
        :class="{ 'item-disabled': type.disabled }"
        @click="onElementTypeClick(type)"
      >
        <div class="img-wrapper-div">
          <img :src="getImgUrl(type.icon)" alt="" />
          <span>
            {{ type.caption }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formBuilderV3Elements } from '@/utils/constants/FormBuilderConstants.js';
import { showScrollbar } from '@/utils/helpers';
export default {
  name: 'FormElementSelectionModal',
  data() {
    return {
      searchElementType: '',
    };
  },
  props: {
    elementsToShow: {
      type: Array,
      default: () => [],
    },
    elementsToHide: {
      type: Array,
      default: () => [],
    },
    elements: {
      type: Array,
      default: () => [],
    },
    isUserHasAccess: { type: Boolean, default: true },
    dropDownTop: {
      type: Number,
      default: 200,
    },
    isNewFormElement: {
      type: Object,
      default: () => {},
    },
    isInsideGrid: {
      type: Boolean,
      default: () => {},
    },
    singleInstanceElementTypes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    setScrollbar(event) {
      showScrollbar(this, event);
    },
    onElementTypeClick(type) {
      if (type?.disabled) return;
      this.$emit('addElement', type.element);
    },
    getImgUrl(img) {
      const images = require.context('@/assets/img/', false, /\.svg$/);
      return images(img);
    },
  },
  computed: {
    filterElementTypeList() {
      let tempTypeList;

      if (this.elementsToShow && this.elementsToShow.length) {
        tempTypeList = formBuilderV3Elements.filter((e) =>
          this.elementsToShow.includes(e.name)
        );
      } else if (this.elementsToHide && this.elementsToHide.length > 0) {
        tempTypeList = formBuilderV3Elements.filter(
          (el) => !this.elementsToHide.includes(el.name.trim())
        );
      } else {
        tempTypeList = formBuilderV3Elements;
      }
      if (!this.isUserHasAccess) {
        tempTypeList = tempTypeList.filter(
          (type) => type.element.settings.layoutItem
        );
      }
      tempTypeList = tempTypeList.filter(
        (el) =>
          (el.name === 'togglelist'
            ? this.isNewFormElement?.level < 2
            : true) &&
          el.caption
            ?.toLowerCase()
            ?.includes(this.searchElementType?.trim()?.toLowerCase())
      );
      // hide grid element for nested grids

      const hiddenElementsInGrid = ['grid'];
      tempTypeList = tempTypeList.filter((el) => {
        if (this.isInsideGrid) {
          return !hiddenElementsInGrid.includes(el?.name);
        }

        return true;
      });

      if (this.singleInstanceElementTypes.length) {
        const existingTypes = new Set(
          this.elements.map((element) => element.type)
        );
        tempTypeList = tempTypeList.map((el) => {
          const elementType = el?.element?.type || el?.type || el?.name;
          return this.singleInstanceElementTypes.includes(elementType) &&
            existingTypes.has(elementType)
            ? { ...el, disabled: true }
            : el;
        });
      }

      return tempTypeList;
    },
  },
};
</script>

<style scoped>
.form-element-drop-down * {
  box-sizing: border-box;
}

.form-element-drop-down {
  font-size: 14px;
  color: #4a556a;
  font-family: sans-serif;
  -webkit-font-smoothing: unset;
  padding: 11px;
  border-radius: 9px;
  box-shadow: 0 2px 8px rgb(31 37 50 / 18%);
  position: absolute;
  z-index: 100;
  width: 270px;
  list-style: none;
  background-color: #fff;
  overflow: hidden;
  border: none;
  left: 40%;
  right: 100%;
  top: 200px;
}
.form-element-drop-down img {
  background-color: #fefbfb;
  vertical-align: middle;
  border-style: none;
  width: 78px;
  height: 78px;
  padding: 13px;
  margin: 4px;
  border-radius: 5px;
  border: 1px solid #d2d0d0;
}

.form-element-drop-down .form-element-search-wrapper {
  border: 1px solid #97979e;
  margin-left: 8px;
  padding: 2px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  height: 36px;
  gap: 4px;
}

.form-element-drop-down .form-element-search-wrapper input {
  width: 100%;
  outline: none;
  font-size: 14px;
  color: #4a556a;
}

.form-element-drop-down .form-element-search-wrapper .search-icon {
  border: none !important;
  background: transparent !important;
  width: 24px !important;
  padding: 0 !important;
  margin: 0 !important;
  margin-left: 4px !important;
  height: 24px !important;
}

.form-element-drop-down .element-list-wrapper {
  overflow: auto;
  max-height: calc(100vh - 420px);
  margin-block: 8px;
}

.form-element-drop-down .item {
  padding: 5px;
  border-radius: 5px;
  width: 100%;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
}

.form-element-drop-down .item:hover {
  background: #f1efef;
}

.form-element-drop-down .item.item-disabled {
  background: #e3e3e3fc !important;
  color: #a3a3a3;
  cursor: not-allowed;
  opacity: 0.6;
}

.form-element-drop-down .item.item-disabled img {
  background: #e3e3e3fc !important;
  color: #a3a3a3;
}
</style>
